import { h, Host } from "@stencil/core";
/** @internal */
export class Popper {
  render() {
    return h(Host, null);
  }
  static get is() { return "es-popper-x"; }
}
//# sourceMappingURL=es-popper-x.js.map
